module.exports = __webpack_public_path__ + "static/media/straps-desktop.a1172526.png";